// extracted by mini-css-extract-plugin
module.exports = {"container":"eventTag_container__38VVe","isSelected":"eventTag_isSelected__2J9-i"};
    if(module.hot) {
      // 1783592063667
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  